export default "__VITE_ASSET__rQc4N9AE__"